import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import { container, spacing } from '../../../theme';

export const StyledTeam = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  max-width: ${container('xl')};
  width: 100%;
  margin: auto;

  ${Heading1} {
    text-align: center;
  }
`;

export const StyledTeamCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl4')};
`;
